<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    @checkTable="checkTable"
    ref="table"
  >
    <template #DETAILS="{ visible, params, close }">
      <Details v-if="visible" :row="params" :close="close"></Details>
    </template>
  </cTable>
</template>

<script>
import {
  getClientBill,
  getItemDetails,
  deleteItem,
  getCountryCurrency,
  saveCountryCurrency,
  apendCnbNumbers,
  updateItem,
  batchWriteOff,
  cancelWriteOff,
  codConfirmBill,
  cancelConfirmBill,
} from "@/api/branch/cod-refund";
import { getAllClient } from "@/api/user/client";
import { getCurrency } from "@/api/finance/currency";
import { getSearchConfig } from "@/api/finance/cod";
import { getBank } from "@/api/finance/bank";
import { getCodRate, getRateDetails } from "@/api/finance/cod_rate";
import { getCompanyConfig } from "@/api/user/branch";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import Details from "./details";

export default {
  name: "branch_cod_refund",
  components: {
    cTable,
    Details,
  },
  methods: {
    checkTable(val) {
      let checkNum = numFun.sumNumFun(val, "total_real_amount", 2);
      this.totalAmount.forEach((item) => {
        if (item.text == this.$t("total") + this.$t("selected")) {
          item.total_amount = checkNum;
        }
      });
    },
  },
  data() {
    return {
      totalAmount: [],
      methods: {
        list: getClientBill,
        getItemDetails,
        deleteItem,
        getCountryCurrency,
        getRateDetails,
        getCodRate,
        saveCountryCurrency,
        apendCnbNumbers,
        getCompanyConfig,
        updateItem,
        getCurrency,
        getBank,
        batchWriteOff,
        cancelWriteOff,
        codConfirmBill,
        cancelConfirmBill,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push(
            {
              text: this.$t("total"),
              replace_currency: "USD",
              total_amount: data.total_usd,
            },
            {
              text: this.$t("total") + this.$t("selected"),
              replace_currency: "USD",
              total_amount: 0,
            }
          );
        },
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("apendCnbNumbers", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_numbers: [
                {
                  required: true,
                  message: "Please Enter airway_number",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ airway_numbers: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 10,
              },
            },
          ],
        },
        update: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("updateItem", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
              total_real_amount: [
                {
                  required: true,
                  message: "Please Enter total_real_amount",
                  type: "number",
                  trigger: "blur",
                },
              ],
              total_fee: [
                {
                  required: true,
                  message: "Please Enter total_fee",
                  type: "number",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { total_fee: 24 },
            { total_real_amount: 24 },
            { name: 24 },
            { rate: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$t("total_fee"),
              key: "total_fee",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("total_fee"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("amount_receivable"),
              key: "total_real_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("turn") + this.$t("to_rmb") + this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 2,
                type: "textarea",
              },
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              this.$page
                .handleRequestMethods("batchWriteOff", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bank: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              check_amount_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              transfer_method: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              transaction_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { bank: 24 },
            { check_amount: 24 },
            { check_amount_currency: 24 },
            { transfer_method: 24 },
            { transaction_id: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$t("bank"),
              key: "bank",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label: ({ row }) => {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "account_type",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
                click({ obj, formData, fields }) {
                  let options = [
                    {
                      label: this.$t("bank1"),
                      value: "bank",
                    },
                    { label: this.$t("alipay"), value: "alipay" },
                  ];
                  fields.forEach((item) => {
                    if (item.key === "transfer_method") {
                      item.options = options.filter(
                        (key) => key.value == obj.b_type
                      );
                      this.$forceUpdate();
                    }
                  });
                  formData.bank_id = obj.id;
                  formData.transfer_method = obj.b_type;
                  formData.check_amount_currency =
                    obj.b_type === "alipay" ? "CNY" : "USD";
                },
              },
            },
            {
              name: this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: this.$t("check_amount_currency"),
              key: "check_amount_currency",
              component: "Select",
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCurrency")
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: this.$t("turn_to"),
              key: "transfer_method",
              component: "Radio",
              bind: {
                border: true,
              },
              options: [
                { label: this.$t("bank1"), value: "bank" },
                // { label: "支付宝", value: "alipay" }
              ],
              default: "bank",
              // methods: {
              //   "on-change"({ row }) {
              //     if (row.transfer_method == "alipay") {
              //       let data = {
              //         ids: this.$page.selectAll.map(item => item.id)
              //       };
              //       checkClientAlipay(data).then(res => {
              //         // console.log(res.data.status);
              //         if (!res.data.status) this.$modal.disabledConfirm = true;
              //       });
              //     } else {
              //       this.$modal.disabledConfirm = false;
              //     }
              //   }
              // }
            },

            {
              name: this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
              show({ row }) {
                return row.transfer_method != "alipay";
              },
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        rate: {
          type: "add",
          methods: {
            ok({ list, row, close }) {
              console.log(list);
              let data = {
                country: list,
                id: this.params.id,
                scheme_id: row.selplan,
              };
              this.$page
                .handleRequestMethods("saveCountryCurrency", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          grid: [
            {
              selplan: 10,
            },
          ],
          fields: [
            {
              key: "selplan",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("planName"),
              options: [],
              config: {
                label: "name",
                value: "id",
              },
              methods: {
                async list({ row, field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCodRate", {
                      pageSize: 999,
                    })
                  ).payload.rows;
                  if (row.selplan) {
                    let data = (
                      await this.$page.handleRequestMethods("getRateDetails", {
                        type: "select",
                        id: row.selplan,
                      })
                    ).payload;
                    if (data) {
                      this.$page.getModal("rate").list.forEach((ele) => {
                        if (data.hasOwnProperty(ele.currency_id)) {
                          ele.rate = data[ele.currency_id];
                        }
                        ele.cny_to_usd = data.hasOwnProperty(4) ? data[4] : 0;
                      });
                    }
                  }
                  this.$forceUpdate();
                },
                async "on-change"({ value }) {
                  if (!value) return;
                  let data = (
                    await this.$page.handleRequestMethods("getRateDetails", {
                      type: "select",
                      id: value,
                    })
                  ).payload;
                  if (data) {
                    this.$page.getModal("rate").list.forEach((ele) => {
                      if (data.hasOwnProperty(ele.currency_id)) {
                        ele.rate = data[ele.currency_id];
                      }
                      ele.cny_to_usd = data.hasOwnProperty(4) ? data[4] : 0;
                    });
                  }
                },
              },
            },
          ],
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: () => this.$t("countryName"),
                key: "title",
                align: "left",
              },
              {
                name: () => this.$t("countryCode"),
                key: "code",
                width: 80,
              },
              {
                name: () => this.$t("currencyCode"),
                key: "currency",
                width: 80,
              },
              {
                name: () => this.$t("rate"),
                key: "rate",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
              },
              {
                name: () => "CNY To USD",
                key: "cny_to_usd",
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%",
                  },
                  step: 0.0001,
                  min: 0,
                },
                methods: {
                  "on-change"({ row }) {
                    this.list.map((item) => (item.cny_to_usd = row.cny_to_usd));
                  },
                },
              },
            ],
          },
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: { show: () => false },
        },
        analyze: {
          footer: {
            show: () => false,
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("export"),
                type: "export",
                fnName: "export",
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",
                  style: {
                    margin: "0 5px",
                  },
                },
              },
            ],
            methods: {
              export() {
                let data = JSON.parse(JSON.stringify(this.data));
                data.export = 1;
                this.$page
                  .handleRequestMethods("getAnalyze", data)
                  .then((res) => {
                    this.$Message[res.status ? "success" : "error"]({
                      background: true,
                      content: res.msg,
                      duration: res.status ? 2 : 5,
                    });
                    if (res.status) {
                      window.open(this.$globalUrl + res.payload);
                    }
                  });
              },
            },
          },
          config: {
            modalBind: {
              width: 1000,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            title: this.$t("statistics"),
            listFn: "getAnalyze",
          },
          table: {
            config: {
              height: 600,
              showFooter: true,
              footerCellClassName: "col-red",
              footerMethod: ({ columns, data }) => {
                const sums = [];
                columns.forEach((column) => {
                  let sumCell = null;
                  switch (column.property) {
                    case "seq":
                      sumCell = this.$t("total");
                      break;
                    case "name":
                      sumCell = "-";
                      break;
                    case "currency":
                      sumCell = "-";
                      break;
                    case "total_votes":
                      sumCell = sumCell = numFun.sumNumFun(
                        data,
                        column.property,
                        2
                      );
                      break;
                    default:
                      sumCell = numFun.sumNumFun(
                        data,
                        column.property,
                        2,
                        "format"
                      );
                  }
                  sums.push(sumCell);
                });
                // 返回一个二维数组的表尾合计
                return [sums];
              },
            },

            fields: [
              {
                name: () => this.$t("alipay_name"),
                key: "name",
                minWidth: 130,
              },
              {
                name: () => this.$t("currencyCode"),
                minWidth: 80,
                key: "currency",
                align: "left",
              },
              {
                name: () => this.$t("SHIPMENTS"),
                key: "total_votes",
                minWidth: 80,
                align: "left",
              },
              {
                name: () =>
                  this.$t("original") +
                  this.$t("currency_t") +
                  this.$t("total_amount"),
                key: "origin_amount",
                minWidth: 130,
                align: "left",
              },
              {
                name: () => this.$t("to_usd"),
                children: [
                  {
                    name: () => this.$t("total_amount"),
                    key: "amount_usd",
                    minWidth: 130,
                    align: "left",
                  },
                  {
                    name: () => this.$t("bill_close_account_issuing_charge"),
                    key: "handling_fee_usd",
                    minWidth: 130,
                    align: "left",
                  },
                  {
                    name: () =>
                      this.$t("receivable") +
                      "/" +
                      this.$t("bill_close_account_issuing_confirm") +
                      this.$t("reChAmount"),
                    key: "confirm_fee_usd",
                    minWidth: 130,
                    align: "left",
                  },
                ],
              },
            ],
          },
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "130px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "130px",
              },
            },
          },
          {
            key: "time_type",
            placeholder() {
              return this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            bind: {
              style: "width:100px",
            },
          },
          {
            key: "client_agent_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },

            component: "Select",
            options: [],
            config: { label: "account", value: "id" },
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "bill_status",
            placeholder() {
              return this.$t("bill_type");
            },
            component: "Select",
            options: [],
            bind: {
              style: "width:100px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("confirm") + this.$t("bill1"),
              type: "confirmed",
              fnName: "confirmed",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "error",
              },
            },
            {
              name: () => this.$t("cancel") + this.$t("confirm"),
              type: "cancelConfirm",
              fnName: "cancelConfirm",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "error",
              },
            },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error",
              },
              id: 714,
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            confirmed() {
              let data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("bill1"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("codConfirmBill", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            cancelConfirm() {
              let data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("confirm"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelConfirmBill", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            writeOff() {
              let data = {
                check_amount_currency: "USD",
                check_amount: parseFloat(
                  this.selectAll
                    .map((item) => item["final_amount"])
                    .reduce((a, b) => a + b)
                    .toFixed(2)
                ),
              };
              this.getModal("writeOff").open(data, function () {
                this.setTitle(this.$t("writeOff"));
                this.disabledConfirm = false;
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("check_bill_number"),
          key: "check_bill_number",
          component: this.$hasPermission(699) ? "Button" : "span",
          minWidth: 140,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ row }) {
              return row.check_bill_number;
            },
            click({ row }) {
              if (this.$hasPermission(699))
                this.$page.getModal("showDetails").open(row, function () {
                  this.setTitle(row.check_bill_number);
                });
            },
          },
        },
        {
          name: () => this.$t("clientName"),
          align: "left",
          key: "client_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("codNAme"),
          key: "name",
          minWidth: 150,
        },
        {
          name: () => this.$t("total_votes"),
          align: "left",
          key: "total_votes",
          width: 70,
        },
        {
          name: "USD",
          children: [
            {
              name: () => this.$t("total_amount"),
              key: "total_amount",
              align: "left",
              width: 110,
            },
            {
              name: () => this.$t("total_fee"),
              align: "left",
              key: "total_fee",
              width: 120,
            },
            {
              name: () => this.$t("amount_refunded"),
              align: "left",
              key: "total_real_amount",
              width: 120,
            },
            {
              name: () => this.$t("deductExpenses"),
              key: "deductible_fee",
              align: "left",
              width: 120,
            },
            {
              name: () =>
                this.$t("orther") +
                this.$t("bill_close_account_issuing_confirm"),
              key: "other_charges",
              align: "left",
              width: 120,
            },
            {
              name: () => this.$t("Not") + this.$t("check_amount"),
              key: "final_amount",
              align: "left",
              width: 120,
            },
            {
              name: () => this.$t("AmountHedged"),
              key: "hedge_amount",
              align: "left",
              width: 120,
            },
          ],
        },
        {
          name: () => this.$t("turn") + "CNY",
          children: [
            {
              name: () => this.$t("rate"),
              key: "usd_to_cny_rate",
              align: "left",
              width: 110,
            },
            {
              name: () => this.$t("amount_actual") + this.$t("amount_refunded"),
              align: "left",
              key: "total_real_amount_cny",
              width: 120,
            },
            {
              name: () => this.$t("NotWrittenOff") + this.$t("reChAmount"),
              align: "left",
              key: "final_amount_cny",
              width: 120,
            },
            {
              name: () => this.$t("AmountHedged"),
              key: "hedge_amount_cny",
              align: "left",
              width: 120,
            },
          ],
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          width: 80,
        },
        {
          name: () => this.$t("finances") + this.$t("order_desc"),
          key: "remarks",
          align: "left",
          width: 100,
        },
        {
          name: () => this.$t("operate"),
          align: "left",
          key: "operator_name",
          width: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
        },
        {
          name: () => this.$t("check_time"),
          key: "check_time",
          width: 150,
        },
        {
          name: () => this.$t("writeOff"),
          children: [
            {
              name: () => this.$t("check_time"),
              key: "check_time",
              width: 150,
            },
            {
              name: () => this.$t("bank"),
              align: "left",
              key: "bank",
              width: 100,
            },
            {
              name: () => this.$t("check_amount"),
              key: "check_amount",
              align: "left",
              width: 100,
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transaction_id",
              align: "left",
              minWidth: 110,
            },
            {
              name: () => this.$t("currencyCode"),
              key: "check_amount_currency",
              align: "left",
              width: 80,
            },
          ],
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 400,
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("addTo"),
              type: "add",
              fnName: "add",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status != 1;
              },
              id: 697,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.status != 1;
              },
              id: 710,
            },

            {
              name: () => this.$t("rate"),
              type: "rate",
              fnName: "rate",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status != 1;
              },
              id: 698,
            },
            {
              name: () => this.$t("cancel") + this.$t("writeOff"),
              type: "noWriteOff",
              fnName: "noWriteOff",
              bind: {
                type: "info",
              },
              disabled({ row }) {
                return row.status != 9;
              },
              id: 716,
            },

            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.status != 1;
              },
              id: 708,
            },
          ],
          methods: {
            analyze({ row }) {
              this.getModal("analyze").open({}, function () {
                this.data = { id: row.id };
                this.$page
                  .handleRequestMethods("getAnalyze", this.data)
                  .then((res) => {
                    this.list = res.payload;
                  });
                this.setTitle(
                  row.check_bill_number + "(" + this.$t("statistics") + ")"
                );
              });
            },
            add({ row }) {
              this.getModal("add").open({ id: row.id }, function () {
                this.setTitle(
                  row.check_bill_number + "(" + this.$t("addTo") + ")"
                );
              });
            },
            update({ row }) {
              this.handleRequestMethods("getItemDetails", row.id).then(
                (res) => {
                  let data = res.payload;
                  data.rate = parseFloat(res.payload.usd_to_cny_rate);
                  this.getModal("update").open(data, function () {
                    this.setTitle(
                      row.check_bill_number + "(" + this.$t("update") + ")"
                    );
                  });
                }
              );
            },
            noWriteOff({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") + this.$t("cancel") + this.$t("writeOff"),
                width: 300,
                content: this.$t("bill1") + "(" + row.check_bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("cancelWriteOff", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            rate({ row }) {
              this.handleRequestMethods("getCountryCurrency", row.id).then(
                (res) => {
                  let data = res.payload.map((item) => {
                    item.rate = item.currency.rate_to_usd;
                    item.cny_to_usd = item.currency.cny_to_usd;
                    item.currency = item.currency.code;
                    item.country = item.code;
                    return item;
                  });
                  this.getModal("rate").open(
                    { id: row.id, selplan: row.scheme_id },
                    function () {
                      this.setTitle(
                        row.check_bill_number + "(" + this.$t("rate") + ")"
                      );
                      this.list = data;
                    }
                  );
                }
              );
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.check_bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("deleteItem", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
  activated() {
		if(this.$store.state.user.pageUrl){
			this.$refs["table"].$refs["header"].searchForm.keywords =
				this.$store.state.user.pageUrl;
			this.$store.state.user.pageUrl = "";
			this.$refs["table"].getList();
		}
  },
  async mounted() {
    let companiesList = (await getCompanyConfig()).data.payload.company;
    let data = (await getSearchConfig()).data.payload;
    let data1 = (await getAllClient()).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "time_type")
        item.options = Object.keys(data.time_type).map((item) => ({
          value: item,
          label: data.time_type[item],
        }));
      if (item.key === "bill_status")
        item.options = Object.keys(data.receive_bill).map((item) => ({
          value: item,
          label: data.receive_bill[item],
        }));
      if (item.key === "client_agent_id") item.options = data1;
      if (item.key === "ownership") item.options = companiesList;
    });
  },
};
</script>
